// api/Device

import request from "@utils/request"

const url = "api/Device/"

/**
 *
 *  设备导入
 * @export
 * @param {*} data
 * @return {*}
 */
export function ImportGateways (data) {
  return request({
    url: url + "ImportGateways",
    method: "post",
    data
  })
}

/**
 *
 * 单个设备导入
 * @export
 * @param {*} data
 * @return {*}
 */
export function SingleImportGateways (data) {
  return request({
    url: url + "SingleImportGateways",
    method: "post",
    data
  })
}

/**
 *
 * 查询临时表导入数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryTempData (data) {
  return request({
    url: url + "QueryTempData",
    method: "post",
    data
  })
}

/**
 *
 * 将临时表数据提交到正式表
 * @export
 * @param {*} data
 * @return {*}
 */
export function CommitToDb (data) {
  return request({
    url: url + "CommitToDb",
    method: "post",
    data
  })
}

/**
 *
 * 分页查询设备列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryGateways (data) {
  return request({
    url: url + "QueryGateways",
    method: "post",
    data
  })
}

/**
 *
 * 根据Id删除设备
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteGateways (data) {
  return request({
    url: url + "DeleteGateways",
    method: "post",
    data
  })
}

/**
 *
 * 更改设备
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateGateways (data) {
  return request({
    url: url + "UpdateGateways",
    method: "post",
    data
  })
}

/**
 *
 * 批删采集器
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteAllGateway (data) {
  return request({
    url: url + "DeleteAllGateway",
    method: "post",
    data
  })
}

/**
 *
 * 批量删除逆变器
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteAllDevice (data) {
  return request({
    url: url + "DeleteAllDevice",
    method: "post",
    data
  })
}

/**
 *
 * 将设备授权给用户
 * @export
 * @param {*} data
 * @return {*}
 */
export function Auth (data) {
  return request({
    url: url + "Auth",
    method: "post",
    data
  })
}

/**
 *
 * 取消授权(分销商安装商)
 * @export
 * @param {*} data
 * @return {*}
 */
export function RemoveAuth (data) {
  return request({
    url: url + "RemoveAuth",
    method: "post",
    data
  })
}

/**
 *
 * 获取逆变器的组串路数（电站 - 历史，组串路数在历史的逆变器列表中一并返回）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetSolarPvNum (data) {
  return request({
    url: url + "GetSolarPvNum",
    method: "post",
    data
  })
}

/**
 *
 * 修改采集器别名
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateGatewayAlias (data) {
  return request({
    url: url + "UpdateGatewayAlias",
    method: "post",
    data
  })
}

/**
 *
 * 根据id获取采集器信息（通用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetGatewayById (data) {
  return request({
    url: url + "GetGatewayById",
    method: "post",
    data
  })
}

/**
 *
 * 更新设备信息（通用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateDevice (data) {
  return request({
    url: url + "UpdateDevice",
    method: "post",
    data
  })
}

/**
 *
 * 根据id获取设备信息（通用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetDeviceById (data) {
  return request({
    url: url + "GetDeviceById",
    method: "post",
    data
  })
}

/**
 *
 * 获取储能逆变器的【设置参数】值（储能电站 - 逆变器 - 远程设置）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetSettingArguments (data) {
  return request({
    url: url + "GetSettingArguments",
    method: "post",
    data
  })
}

/**
 *
 * 获取储能逆变器的时间（储能电站 - 逆变器 - 远程设置）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetInverterTime (data) {
  return request({
    url: url + "GetInverterTime",
    method: "post",
    data
  })
}

/**
 *
 * 设置储能逆变器的【设置参数】值（储能电站 - 逆变器 - 远程设置）
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateInverterArguments (data) {
  return request({
    url: url + "UpdateInverterArguments",
    method: "post",
    data
  })
}

/**
 *
 * 设置逆变器时间（储能电站 - 逆变器 - 远程设置）
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateInverterTime (data) {
  return request({
    url: url + "UpdateInverterTime",
    method: "post",
    data
  })
}
/**
 *
 * 单个删除临时表数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteImpGateway (data) {
  return request({
    url: url + "DeleteImpGateway",
    method: "post",
    data
  })
}
/**
 *
 * 批量删除临时表数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function BatchDeleteImp (data) {
  return request({
    url: url + "BatchDeleteImp",
    method: "post",
    data
  })
}
/**
 *
 * 修改临时表数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateImp (data) {
  return request({
    url: url + "UpdateImp",
    method: "post",
    data
  })
}
/**
 *
 * 获取分销商或者安装商列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetDistributorsAndInstallers (data) {
  return request({
    url: url + "GetDistributorsAndInstallers",
    method: "post",
    data
  })
}
/**
 *
 * 获取计费方式信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetBillingDirection (data) {
  return request({
    url: url + "GetBillingDirection",
    method: "post",
    data
  })
}

/**
 *
 * 设置计费方式信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function SetBillingDirection (data) {
  return request({
    url: url + "SetBillingDirection",
    method: "post",
    data
  })
}

/**
 *
 * 分页查询摄像头列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryCameras (data) {
  return request({
    url: url + "QueryCameras",
    method: "post",
    data
  })
}

/**
 *
 * 根据电站id获取摄像头列表，用于概览页显示摄像头直播框
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetCamerasByStationId (data) {
  return request({
    url: url + "GetCamerasByStationId",
    method: "post",
    data
  })
}

/**
 *
 * 设备重启
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeviceRestart (data) {
  return request({
    url: url + "DeviceRestart",
    method: "post",
    data
  })
}
